import { UserSession } from '../../models';

export interface SharedErrorEntity {
  userSessionError?: string;
}

export interface SharedEntity extends SharedErrorEntity {
  id: string | number; // Primary ID
  userSession?: UserSession;
}
